export const SECOND = 1000 // 1000 milliseconds
export const MINUTE = 60 * SECOND // 60 seconds
export const HOUR = 60 * MINUTE // 60 minutes
export const DAY = 24 * HOUR // 24 hours

export const FIREBASE_PATH_SUBSCRIPTIONS = "subscriptions"
